"use strict";

// Alias exports to a their normalized format Mocha#reporter to prevent a need
// for dynamic (try/catch) requires, which Browserify doesn't handle.
exports.Base = exports.base = require("./base");
exports.Dot = exports.dot = require("./dot");
exports.Doc = exports.doc = require("./doc");
exports.TAP = exports.tap = require("./tap");
exports.JSON = exports.json = require("./json");
exports.HTML = exports.html = require("./html");
exports.List = exports.list = require("./list");
exports.Min = exports.min = require("./min");
exports.Spec = exports.spec = require("./spec");
exports.Nyan = exports.nyan = require("./nyan");
exports.XUnit = exports.xunit = require("./xunit");
exports.Markdown = exports.markdown = require("./markdown");
exports.Progress = exports.progress = require("./progress");
exports.Landing = exports.landing = require("./landing");
exports.JSONStream = exports["json-stream"] = require("./json-stream");
